module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_brentcomber_2.230d3fba.jpg";